import React from 'react';

import { observer } from 'mobx-react';
import Phone from 'react-phone-number-input';

import InputTextField from './InputTextField';

@observer
class PhoneNumberField extends InputTextField {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(phone) {
    const { onChangeCustomComponent, name } = this.props.input;

    onChangeCustomComponent(phone, name);
  }

  onBlurHandler() {
    this.touched = true;
  }

  get inputComponent() {
    const { value, name, placeholder } = this.props.input;

    return (
      <Phone
        showCountrySelect={false}
        className=""
        inputClassName="input-text"
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={this.onChange}
        onBlur={this.onBlurHandler}
      />
    );
  }
}

export default PhoneNumberField;



// WEBPACK FOOTER //
// ./src/common/components/fields/PhoneNumberField.jsx